// extracted by mini-css-extract-plugin
module.exports = {"container":"section1_container__KCWrL","title":"section1_title__qTYdh","content":"section1_content__sM7zR","cards":"section1_cards__O1RZC"};